'use client';

import { c as _c } from "react/compiler-runtime";
import { SkeletonBar } from '@petsmart-ui/sparky';
import { useMedia } from 'react-use';
import { BREAKPOINTS, useUserSession } from '@libs/common-next';
import { AccountPopover, Authenticated, Unauthenticated } from './components';
import { useAccountSessionLoading } from './use-account-session-loading';
import './account.scss';
const DESKTOP_MEDIA_QUERY = `(min-width: ${BREAKPOINTS.lg}px) and (hover: hover) and (pointer: fine)`;
export function Account() {
  const $ = _c(5);
  const {
    isAuthenticated
  } = useUserSession();
  const isAccountDataLoading = useAccountSessionLoading();
  const isDesktop = useMedia(DESKTOP_MEDIA_QUERY, false);
  const variant = isDesktop ? "desktop" : "mobile";
  if (isAccountDataLoading) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <SkeletonBar className="account__loader" />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (isAuthenticated) {
    let t0;
    if ($[1] !== variant) {
      t0 = <Authenticated variant={variant} />;
      $[1] = variant;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  }
  let t0;
  if ($[3] !== variant) {
    t0 = <AccountPopover key={variant} variant={variant} accountHref="/sign-in">{_temp}</AccountPopover>;
    $[3] = variant;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
}
function _temp(t0) {
  const {
    close
  } = t0;
  return <Unauthenticated onAction={close} />;
}